export default function FileExport({ className }) {
  return(
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed" class={`MuiSvgIcon-root ${className}`}>
    <path d="m202-65-56-57 118-118h-90v-80h226v226h-80v-89L202-65Zm278-15v-320H160v-400q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H480Zm40-520h200L520-800l200 200-200-200v200Z"/>
  </svg>
  )
}


